import { attr, belongsTo } from 'spraypaint';
import BaseApplicationRecord from './ApplicationRecord';
import Supplier from './Supplier';

const Sku = BaseApplicationRecord.extend({
  attrs: {
    allow_split_case: attr({ type: Boolean }),
    case_height_mm: attr({ type: Number }),
    case_length_mm: attr({ type: Number }),
    case_primary_packaging: attr(),
    case_primary_packaging_recycled_content_percent: attr({ type: Number }),
    case_primary_packaging_recycling_method: attr(),
    case_primary_packaging_tare_weight_g: attr({ type: Number }),
    case_secondary_packaging: attr(),
    case_secondary_packaging_recycled_content_percent: attr({ type: Number }),
    case_secondary_packaging_recycling_method: attr(),
    case_secondary_packaging_tare_weight_g: attr({ type: Number }),
    case_weight_kg: attr({ type: Number }),
    case_width_mm: attr({ type: Number }),
    cases_per_layer: attr({ type: Number }),
    code: attr(),
    component_id: attr({ type: Number }),
    description: attr(),
    max_layers: attr({ type: Number }),
    pallet_size: attr(),
    supplier: belongsTo({ type: Supplier, persist: false }),
    supplier_id: attr({ type: Number }),
    case_price: attr(),
    units_per_case: attr({ type: Number }),
  },
  static: {
    endpoint: '/skus',
    jsonapiType: 'suppliers-skus',
  },
});

export default Sku;
